import Rollbar from "rollbar";

export const rollbarErrorTracking = (() => {
  const RollbarObj = new Rollbar({
    accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment:
      !process.env.NODE_ENV || process.env.NODE_ENV === "development"
        ? "development"
        : "production"
  });

  const logErrorInfo = info => {
    RollbarObj.info(info);
  };

  const logErrorInRollbar = error => {
    RollbarObj.error(error);
  };

  return { logErrorInfo, logErrorInRollbar };
})();

export default rollbarErrorTracking;
